export default {
  "首页": "Startseite",
  "订单": "Bestellung",
  "新闻": "Nachrichten",
  "个人中心": "Persönlicher Bereich",
  "模拟账户": "Demokonto",
  "可用资产": "Verfügbare Vermögenswerte",
  "入金": "Einzahlung",
  "出金": "Auszahlung",
  "账单详情": "Rechnungsdetails",
  "重置模拟账户": "Demokonto zurücksetzen",
  "钱包": "Wallet",
  "实名认证": "Identitätsprüfung",
  "邀请好友": "Freunde einladen",
  "修改密码": "Passwort ändern",
  "投诉邮箱": "Beschwerde-E-Mail",
  "其它": "Sonstiges",
  "公告": "Ankündigungen",
  "语言": "Sprache",
  "是否退出登录": "Möchten Sie sich abmelden?",
  "复制": "Kopieren",
  "复制成功": "Erfolgreich kopiert",
  "发送验证码成功": "Bestätigungscode erfolgreich gesendet",
  "请输入密码": "Bitte Passwort eingeben",
  "请再次输入密码": "Bitte Passwort erneut eingeben",
  "复制邀请链接": "Einladungslink kopieren",
  "上传身份": "Bitte Vorder- und Rückseite des Passes/Ausweises hochladen",
  "正面": "Vorderseite",
  "上传正面": "Vorderseite des Passes/Ausweises hochladen",
  "反面": "Rückseite",
  "上传反面": "Rückseite des Passes/Ausweises hochladen",
  "完善信息": "Bitte persönliche Informationen vervollständigen",
  "输入姓名": "Bitte geben Sie Ihren Namen ein",
  "身份证号": "Pass-/Ausweisnummer",
  "输入身份证号": "Bitte geben Sie Ihre Pass-/Ausweisnummer ein",
  "收款货币": "Empfangswährung",
  "银行名称": "Bankname",
  "收款人账户": "Empfängerkonto",
  "货币": "Währung",
  "分店名称": "Filialname",
  "绑定银行卡": "Bankkarte verknüpfen",
  "银行地址": "Bankadresse",
  "账号名称（假名）": "Kontoname (Alias)",
  "绑定数字货币地址": "Kryptowährungsadresse verknüpfen",
  "余额": "Guthaben",
  "联系客服": "Kundendienst kontaktieren",
  "行情": "Markt",
  "其他": "Andere",
  "设置": "Einstellungen",
  "收款人": "Empfänger",
  "添加": "Hinzufügen",
  "确认": "Bestätigen",
  "取消": "Abbrechen",
  "钱包地址": "Wallet-Adresse",
  "请输入": "Bitte eingeben",
  "退出登录": "Abmelden",
  "充值数量": "Aufladungsmenge",
  "提交": "Einreichen",
  "银行卡": "Bankkarte",
  "选择网络": "Netzwerk auswählen",
  "数字货币": "Kryptowährung",
  "上传验证": "Verifizierung hochladen",
  "提币地址": "Abhebungsadresse",
  "数量(USD)": "Menge (USD)",
  "备注": "Bemerkungen",
  "手续费": "Gebühr",
  "预计到账数量": "Voraussichtliche Gutschrift",
  "暂无数据": "Keine Daten verfügbar",
  "入金记录": "Einzahlungsprotokoll",
  "提币记录": "Abhebungsprotokoll",
  "验证码": "Bestätigungscode",
  "邀请码": "Einladungscode",
  "提示": "Hinweis",
  "请输入验证码": "Bitte Bestätigungscode eingeben",
  "姓名": "Name",
  "邮箱登录": "E-Mail-Login",
  "邮箱": "E-Mail",
  "密码": "Passwort",
  "新用户": "Neuer Benutzer",
  "立即加入": "Jetzt beitreten",
  "忘记密码": "Passwort vergessen",
  "登录": "Anmelden",
  "无需开户,立即创建模拟账号进行交易!": "Kein Konto erforderlich, erstellen Sie jetzt ein Demokonto zum Handeln!",
  "电话": "Telefon",
  "再次输入密码": "Passwort erneut eingeben",
  "职业": "Beruf",
  "年收入": "Jahreseinkommen",
  "注册": "Registrieren",
  "邮箱注册": "E-Mail-Registrierung",
  "发送": "Senden",
  "重置密码": "Passwort zurücksetzen",
  "是否重置": "Zurücksetzen?",
  "已重置": "Zurückgesetzt",
  "名称": "Name",
  "注册成功": "Erfolgreich registriert",
  "加载中": "Wird geladen",
  "您还未登录，请先登录": "Sie sind noch nicht angemeldet, bitte melden Sie sich zuerst an",
  "退出成功": "Erfolgreich abgemeldet",
  "市价": "Marktpreis",
  "挂单": "Limit-Order",
  "倍数": "Multiplikator",
  "止盈": "Take Profit",
  "止损": "Stop Loss",
  "买入数量": "Kaufmenge",
  "每手": "Pro Lot",
  "预估手续费": "Geschätzte Gebühr",
  "预估保证金": "Geschätzte Margin",
  "买入": "Kaufen",
  "卖出": "Verkaufen",
  "您的订单已确认": "Ihre Bestellung wurde bestätigt",
  "订单页面": "Bestellseite",
  "盈亏": "Gewinn und Verlust",
  "当前保证金": "Aktuelle Margin",
  "订单详情": "Bestelldetails",
  "保证金": "Margin",
  "平仓": "Position schließen",
  "修改": "Ändern",
  "手数": "Lots",
  "暂无数据": "Keine Daten verfügbar",
  "历史": "Verlauf",
  "价格": "Preis",
  "请输入价格": "Bitte Preis eingeben",
  "手": "Lot",
  "搜索结果": "Suchergebnisse",
  "搜索产品": "Produkt suchen",
  "持仓": "Offene Positionen",
  "语言": "Sprache",
  "审核中": "In Prüfung",
  "请上传证件照正/反面": "Bitte Vorder- und Rückseite des Ausweises hochladen",
  "上传成功": "Erfolgreich hochgeladen",
  "上传失败": "Hochladen fehlgeschlagen",
  "提交成功": "Erfolgreich eingereicht",
  "删除": "Löschen",
  "删除成功": "Erfolgreich gelöscht",
  "提币": "Krypto abheben",
  "缺少参数或传值错误": "Fehlende Parameter oder falsche Eingabe",
  "操作成功": "Erfolgreich ausgeführt",
  "充值金额": "Aufladebetrag",
  "类型": "Typ",
  "状态": "Status",
  "时间": "Zeit",
  "单位": "Einheit",
  "最高价": "Höchstpreis",
  "最低价": "Tiefstpreis",
  "开盘价": "Eröffnungspreis",
  "请注册或登录真实账号": "Bitte registrieren oder mit einem echten Konto anmelden",
  "没有更多了": "Keine weiteren Daten",
  "提现金额": "Abhebungsbetrag",
  "审核通过": "Prüfung bestanden",
  "审核不通过": "Prüfung nicht bestanden",
  "重新提交": "Erneut einreichen",
  "止盈价": "Take-Profit-Preis",
  "止损价": "Stop-Loss-Preis",
  "总盈亏": "Gesamter Gewinn/Verlust",
  "撤单": "Bestellung stornieren",
  "请先进行实名认证": "Bitte zuerst die Identitätsprüfung abschließen",
  "产品列表": "Produktliste",
  "下单": "Bestellung aufgeben",
  "可用资金": "Verfügbare Mittel",
  "欢迎登录": "Willkommen bei der Anmeldung",
  "可用": "Verfügbar",
  "冻结": "Eingefroren",
  "财务记录": "Finanzaufzeichnungen",
  "交易对": "Handelspaare",
  "开仓时间": "Eröffnungszeit",
  "收益": "Gewinn",
  "操作": "Aktion",
  "下单价": "Bestellpreis",
  "当前价": "Aktueller Preis",
  "订单号": "Bestellnummer",
  "请选择": "Bitte wählen",
  "卖出(做空)止损价不能低于开仓价": "Stop-Loss für Verkauf (Short) darf nicht unter dem Eröffnungspreis liegen",
  "卖出(做多)止盈价不能高于开仓价": "Take-Profit für Verkauf (Long) darf nicht über dem Eröffnungspreis liegen",
  "买入(做多)止损价不能高于开仓价": "Stop-Loss für Kauf (Long) darf nicht über dem Eröffnungspreis liegen",
  "买入(做多)止盈价不能低于开仓价": "Take-Profit für Kauf (Long) darf nicht unter dem Eröffnungspreis liegen",
  "买入(做多)止盈价不能低于开仓价和现价": "Take-Profit für Kauf (Long) darf nicht unter dem Eröffnungspreis und dem aktuellen Preis liegen",
  "买入(做多)止损价不能高于开仓价和现价": "Stop-Loss für Kauf (Long) darf nicht über dem Eröffnungspreis und dem aktuellen Preis liegen",
  "卖出(做空)止损价不能低于开仓价和现价": "Stop-Loss für Verkauf (Short) darf nicht unter dem Eröffnungspreis und dem aktuellen Preis liegen",
  "卖出(做多)止盈价不能高于开仓价和现价": "Take-Profit für Verkauf (Long) darf nicht über dem Eröffnungspreis und dem aktuellen Preis liegen",

  "提现手续费": "Bearbeitungsgebühr für Auszahlungen",
  "提现退回": "Rücknahmeerstattung",
  "系统加款": "Systemerweiterungen",
  "系统减款": "Reduzierung des Systems",

  "交易周期": "Transaktionszyklus",
  "秒": "Sekunde",
  "交易额": "Transaktionsbetrag",
  "买涨": "Bei steigenden Kursen kaufen",
  "买跌": "Bei fallenden Kursen kaufen",
  "秒数": "Anzahl der Sekunden",
  "交易类型": "Transaktionstyp",
  "看涨": "Auf Kurssteigerung hoffen",
  "看跌": "Auf Kursrückgang hoffen",
  "剩余时间": "Verbleibende Zeit",
  "买入价": "Kaufpreis",
  "结算价": "Abwicklungspreis",
  "交易额": "Transaktionsbetrag",
  "下单时间": "Bestellzeitpunkt",
  "结算时间": "Abwicklungszeitpunkt",
  "该币种暂无交易": "Derzeit gibt es keine Transaktionen für diese Währung",

  "总资产": "Gesamtvermögen",
  "币种": "Währung",
  "资产折合": "Wertumrechnung der Vermögenswerte",
  "冻结金额": "Geblockter Betrag",
  "可用金额": "Verfügbare Summe",
  "公司资产": "Unternehmensvermögen",
  "请输入旧密码": "Bitte geben Sie das alte Passwort ein",
  "请输入新密码": "Bitte geben Sie das neue Passwort ein",
  "请再次输入新密码": "Bitte geben Sie das neue Passwort erneut ein",
  "白皮书": "Weißer Papier",
  "注册证书": "Registraturbescheinigung",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Das Endinterpretationsrecht für die obigen Informationen liegt bei der offiziellen Seite.",
  "上一页": "Vorherige Seite",
  "下一页": "Nächste Seite",
  "关闭": "Schließen",
  "闪电兑换": "Blitzumtausch",
  "全部": "Alles",
  "可用余额": "Verfügbales Guthaben",
  "到": "Bis",
  "请输入数量": "Bitte geben Sie die Menge ein",
  "币种选择": "Währungswahl",
  "从": "Von",
  "兑换": "Tauschen",
  "兑换成功！": "Der Tausch war erfolgreich!",
  "支付": "Zahlen",
  "全部兑换成功": "Alle Tausche waren erfolgreich",
  "获取": "Erhalten",
  "数量": "Menge",
  "拒绝原因": "Grund ablehnen",
  "交易密码": "Transaktionspasswort",
  "设置交易密码": "Transaktionspasswort festlegen",
  "重置交易密码": "Transaktionspasswort zurücksetzen",
  "确定": "Bestätigen",
  "是否购买？": "Kaufen?",
  "外汇": "Devisen",
  "期权": "Optionen",
  "(用户中心)": "(Benutzerzentrum)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Ihre Transaktion wird verarbeitet. Bitte warten Sie geduldig, bis die Transaktion abgeschlossen ist, bevor Sie andere Vorgänge ausführen!",
  "继续下单": "Weiter bestellen",
  "交易方向": "Handelsrichtung",
  "实现盈利": "Gewinn erzielen",
  "最新价格": "Aktueller Preis",
  "结算完成": "Abrechnung abgeschlossen",
  "下单余额不足": "Unzureichendes Guthaben für die Bestellung",
  "输入交易额度": "Handelsbetrag eingeben",
  "选择交易周期": "Handelszeitraum auswählen",
  "审核拒绝": "Überprüfung abgelehnt",
  "请输入正确的数量!": "Bitte geben Sie die korrekte Menge ein!",
  "上传身份": "Identität hochladen",
  "上传正面": "Vorderseite hochladen",
  "上传反面": "Rückseite hochladen",
  "完善信息": "Informationen vervollständigen",
  "输入姓名": "Name eingeben",
  "输入身份证号": "Personalausweisnummer eingeben",
  "身份证号": "Personalausweisnummer",
  "请上传证件照正/反面": "Bitte Vorder- und Rückseite des Dokuments hochladen",
  "最小提现金额10USDT": "Mindestauszahlungsbetrag 10 USDT",
  "证件号码": "Ausweisnummer",
  "输入证件号码": "Ausweisnummer eingeben",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Bitte laden Sie entweder Ihren Personalausweis, Führerschein oder Reisepass zur Identitätsverifizierung hoch!"


}
